// extracted by mini-css-extract-plugin
module.exports = {"info":"post-info_info__NGpTa","dot":"post-info_dot__JX54p","categories":"post-info_categories__ziKep","category":"post-info_category__xjN6T"};